import { render, staticRenderFns } from "./LastRiskEvaluation.vue?vue&type=template&id=1cb2d4c8"
import script from "./LastRiskEvaluation.vue?vue&type=script&lang=js"
export * from "./LastRiskEvaluation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports